import {
  PARTNER_PORTAL_NEW_BRANDING_FEATURE_FLAG,
  useLaunchDarklyFlags,
} from "../launchdarkly/ClientSideLDProvider";

export const useNewBrandStyle = (): boolean => {
  const { flags, isReady } = useLaunchDarklyFlags();
  return isReady && Boolean(flags?.[PARTNER_PORTAL_NEW_BRANDING_FEATURE_FLAG]);
};
